import { useState, useEffect } from "react";
import { useContext } from "react";
import PortalContext from "../../Pages/PortalContext";
import { useGetTranslation } from "../../Components/Translate";
import "./skuRow.css";

export default function SkuRowMobile(props) {
  const { portal } = useContext(PortalContext);
  const getTranslation = useGetTranslation();

  const selected = !!props.itemState?.selected;

  const [quantity, setQuantity] = useState(
    typeof props.itemState?.quantity === "number" ? props.itemState.quantity : 0
  );

  const handleChange = (eventOrValue, optionalName) => {
    // Support checkbox boolean updates with explicit field name
    if (typeof eventOrValue === "boolean" && optionalName) {
      props.setItem(props.index, { [optionalName]: eventOrValue });
      return;
    }

    const event = eventOrValue;
    const name = event.target.name;
    const value =
      event.target.type === "checkbox" ? event.target.checked : event.target.value;

    // Map legacy field names to normalized keys
    if (name === "return") {
      props.setItem(props.index, { selected: value });
      return;
    }
    if (name === "quantity") {
      const num = Number(value) || 0;
      setQuantity(num);
      props.setItem(props.index, { quantity: num });
      return;
    }
    // reason / action
    props.setItem(props.index, { [name]: value });
  };

  useEffect(() => {
    if (selected) {
      const q = props.itemState?.quantity ?? 1;
      const next = q > 0 ? q : 1;
      setQuantity(next);
      if (!props.itemState?.quantity || props.itemState.quantity <= 0) {
        props.setItem(props.index, { quantity: next });
      }
    } else {
      setQuantity(0);
      props.setItem(props.index, { quantity: 0 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <>
      <div class="row mt-4 item-border-mobile switch-mobile">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ width: "100%" }}
        >
          <div className="mb-0 ml-2 w-1/3">
            <label
              className="custom-checkbox"
              style={{
                "--checkbox-bg": '#e4e8ecff',
                "--checkbox-inner": "white",
                "--checkbox-inner-checked": props.item.dangerous
                  ? "orange"
                  : portal.data.settings.colours.primary,
              }}
            >
              <input
                type="checkbox"
                checked={selected}
                onChange={(e) => handleChange(e)}
                name="return"
              />
              <span className="checkmark"></span>
            </label>
          </div>

          <div
            className="body-text w-1/3"
            style={{
              maxWidth: "50%",
              overflow: "hidden",
            }}
          >
            {props.item.SKU_name} {props.item.SKU_name} {props.item.SKU_name}{" "}
          </div>

          <div className="w-1/3 mr-2">
            <img
              src={props.item.SKU_image_URL}
              className="img-fluid rounded"
              style={{ maxHeight: "80px" }}
              alt="Product"
            />
          </div>
        </div>

        {selected && (
          <>
            <div class="col-sm-2 toggle-button mt-2">
              <div
                className="toggle-button"
                style={{ display: "flex", alignItems: "center" }}
              >
                <a
                  onClick={() => {
                    if (!selected) {
                      return;
                    } else {
                      const next = quantity === 0 ? 0 : quantity - 1;
                      setQuantity(next);
                      handleChange({ target: { name: "quantity", value: next } });
                    }
                  }}
                  style={{
                    fontSize: "15px",
                    marginRight: "0px",
                    width: "30px",
                    height: "40px",
                    backgroundColor: !selected ? "#f5f6f7" : "white",
                    border: "1px solid #ccc",
                    marginLeft: "25%",
                    borderRadius: "5px 0px 0px 5px",
                    padding: "10px",
                  }}
                >
                  -
                </a>

                <input
                  type="number"
                  value={quantity}
                  readOnly
                  disabled={!selected ? true : false}
                  className="quantity-input"
                  style={{
                    textAlign: "center",
                    width: "50px",
                    height: "40px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "0px",
                  }}
                />

                <a
                  onClick={() => {
                    if (!selected) {
                      console.log("not checked");
                      return;
                    } else {
                      const next = (quantity || 0) + 1;
                      setQuantity(next);
                      handleChange({ target: { name: "quantity", value: next } });
                    }
                  }}
                  style={{
                    fontSize: "15px",
                    marginRight: "0px",
                    width: "30px",
                    height: "40px",
                    backgroundColor: !selected ? "#f5f6f7" : "white",
                    border: "1px solid #ccc",
                    borderRadius: "0px 5px 5px 0px",
                    padding: "10px",
                  }}
                >
                  +
                </a>
              </div>
            </div>

            <div class="col-sm-3 dropdown-border mt-2">
              <select
                id="reason"
                name="reason"
                onChange={handleChange}
                className=""
                required
                value={props.itemState?.reason || ""}
                disabled={!selected ? true : false}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  backgroundColor: "white",
                  color: "black",
                  paddingRight: "2.5rem",
                  backgroundImage:
                    "url(\"data:image/svg+xml;utf8,<svg fill='%2333' height='12' viewBox='0 0 20 20' width='12' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 0.75rem center",
                  backgroundSize: "1rem",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              >
                <option value={""}>Select reason</option>
                {portal.data.settings.reasonsList.map((item) => {
                  return (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </div>
            <div class="col-sm-2 mt-2">
              <select
                id="action"
                name="action"
                className=""
                required
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  backgroundColor: "white",
                  color: "black",
                  paddingRight: "2.5rem",
                  backgroundImage:
                    "url(\"data:image/svg+xml;utf8,<svg fill='%2333' height='12' viewBox='0 0 20 20' width='12' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 0.75rem center",
                  backgroundSize: "1rem",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
                value={props.itemState?.action || ""}
                onChange={handleChange}
                disabled={!selected ? true : false}
              >
                <option value={""}>Select action</option>
                {portal.data.settings.actionsList.map((item) => {
                  return (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </div>
          </>
        )}
      </div>
    </>
  );
}
